import React from 'react';
import { Chip } from '@mui/material';
import { Text, Theme, i18n, tokens } from '@simplybenefits/sb-ui-library';
import UsageBlock from './UsageBlock.js';
import { helpers } from "@simplybenefits/sb-utils";
import Tooltip from '@mui/material/Tooltip';
import { Info as InfoIcon } from '@mui/icons-material';

/**
 * 
 * @param {*} tooltipText 
 * @param {*} text
 * @returns 
 */
const TextLine = ({ tooltipText, text }) => (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <Tooltip
                title={ tooltipText }
                arrow
                placement="top"
            >
                <InfoIcon aria-label="info" style={{ fontSize: 15, color: Theme.colors.mediumGrey, marginRight: 10 }} />
            </Tooltip>
            <Text small bold>{ text }</Text>
        </div>
    </div>
);

/**
 * @param usage
 * @param fillColor
 * @param waivedEHC
 * @returns {*}
 * @constructor
 */
const DrugsUsageBlock = ({ usage, fillColor, waivedEHC }) => {
    const {
        isFamilyCombinedMaximum,
        familyCombinedMaximum,
        familyCombinedAmountRemaining,
        usageObject
    } = usage;

    return (
        <React.Fragment>
            <div style={{ marginTop: 20 }}>
                <Text
                    medium
                    bold
                    customStyle={{ 
                        flex: 1,
                        display: 'inline',
                        margin: '20px 0 10px 0'
                    }}
                >
                    Drugs
                </Text>

                {
                    waivedEHC ?
                        <Chip
                            size="small"
                            label="Waived"
                            color="primary"
                            variant="outlined"
                            style={{
                                margin: "5px 10px",
                                borderRadius: 30,
                                borderWidth: 2,
                                borderColor: Theme.colors.lightGrey,
                                fontFamily: Theme.fonts.type.heading,
                                fontSize: 14,
                                color: '#666'
                            }}
                        />
                        : null
                }

                <div style={{ marginBottom: 5 }}>
                    {
                        isFamilyCombinedMaximum
                            ? (
                                <TextLine 
                                    tooltipText={i18n.t(tokens.labels.coverage.spendUpToAmountOnDrugServicesFamilyMaximum, { amount: helpers.numberWithCommasDecimals(familyCombinedAmountRemaining) })}
                                    text={ i18n.t(tokens.labels.coverage.drugsFamilyMaximumRemaining, { remaining: helpers.numberWithCommasDecimals(familyCombinedAmountRemaining), combinedMax: helpers.numberWithCommasDecimals(familyCombinedMaximum) }) }
                                />
                            )
                            : null
                    }
                </div>
            </div>

            {
                Object.entries(usageObject).map(([ key, item ]) => {
                    if (item.showItem) {
                        return (
                            <UsageBlock
                                key={ key }
                                usage={{
                                    type: item.title,
                                    used: item.used,
                                    limit: item.limit
                                }}
                                fillColor={ fillColor }
                                limitText={ item.limitText }
                                showRemaining={ !item.limitText }
                            />
                        );
                    }

                    return null;
                })
            }
        </React.Fragment>
    ); 
};

export default DrugsUsageBlock;